export const colors = {
  orange: "#edbd7f",
  blue: "#62789d",
  darkBlue: "#64748a",
  lightBlue: "rgba(127, 174, 195, 1)",
  green: "#ACED80",
  red: "#ED7E89",
  black: "#000",
  white: "#FFF",
  offBlue: "#a9b4c0",
};
